import { FunctionComponent } from 'react';
import { NumericFormat } from 'react-number-format';

interface PlanComponentProps {
	value: number | undefined;
	decimalScale?: number;
	percentage?: boolean;
	style?: React.CSSProperties;
}

const NumberElement: FunctionComponent<PlanComponentProps> = ({ value, decimalScale = 0, style, percentage }) => {
	return (
		<NumericFormat
			value={value}
			displayType="text"
			thousandSeparator=","
			decimalScale={decimalScale}
			fixedDecimalScale={!!decimalScale}
			renderText={(value) => {
				const [intPart, decPart] = value.split('.');
				return (
					<div style={style} dir="ltr">
						{intPart}
						{decPart !== undefined && <span style={{ transform: 'scale(.9)translateY(1px)', display: 'inline-block', ...style }}>.{decPart}</span>}
						{percentage && <span>%</span>}
					</div>
				);
			}}
		/>
	);
};

export default NumberElement;
